<template>
	<div>
		<!-- 合同信息 -->
		<!-- <h3 style="padding: 10px;">合同信息</h3> -->
		<section>
			<el-form :model="formInline" :inline="true" label-width="80px">
				<el-form-item label="所属单位">
					<el-autocomplete v-model="formInline.company" :fetch-suggestions="querySearchAsync"
						placeholder="请输入所属单位" value-key="unitName" clearable @clear="clearSearch"
						ref="myAutocomplete"></el-autocomplete>
				</el-form-item>
				<el-form-item label="人才姓名">
					<el-input v-model="formInline.name" placeholder="输入人才姓名" style="width: 120px;"></el-input>
				</el-form-item>
				<!-- <el-form-item label="手机号">
					<el-input v-model="formInline.phone" placeholder="输入手机号" style="width: 120px;"></el-input>
				</el-form-item> -->
				<el-form-item prop="roomNum" label="房间号">
					<el-input v-model="formInline.roomNum" placeholder="输入房间号" style="width: 120px;"></el-input>
				</el-form-item>
				<!-- <el-form-item label="审批状态">
					<el-select style="width: 140px;" v-model="formInline.status" placeholder="请选择合同类型">
						<el-option label="未审批" value="未审批"></el-option>
						<el-option label="已拒绝" value="已拒绝"></el-option>
						<el-option label="已同意" value="已同意"></el-option>
					</el-select>
				</el-form-item> -->
				<!-- <el-form-item label="时间排序">
					<el-select style="width: 140px;" v-model="formInline.sort" placeholder="请选择合同类型">
						<el-option label="开始时间升序" value="1"></el-option>
						<el-option label="开始时间降序" value="2"></el-option>
						<el-option label="结束时间升序" value="3"></el-option>
						<el-option label="结束时间降序" value="4"></el-option>
						<el-option label="签约时间升序" value="5"></el-option>
						<el-option label="签约时间降序" value="6"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="退房时间">
					<el-date-picker
					  clearable
					  size="small"
					  v-model="formInline.queryDate"
					  type="daterange"
					  align="right"
					  unlink-panels
					  range-separator="至"
					  start-placeholder="开始日期"
					  end-placeholder="结束日期"
					  value-format="yyyy-MM-dd"
					>
					</el-date-picker>
				  </el-form-item>
				<el-form-item>
					<el-button @click="getAll" type="primary">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="handleClear">清空</el-button>
					<el-popover placement="bottom" width="150" v-model="show" class="left10 right10">
						<el-checkbox-group v-model="checkList" @change="checkChange">
							<el-checkbox :label="val" v-for="(val,key) in oldTitleObj" :key="key"
								:disabled="val==oneRow"></el-checkbox>
						</el-checkbox-group>
						<el-button slot="reference">筛选列表</el-button>
					</el-popover>
				</el-form-item>

				<div style="float: right;margin-right: 20px;">
				<!-- 	<div style="display: inline-block;margin-right: 10px;">
						<el-upload action="/api/bdContract/importContract" name="multipartFile" :show-file-list="false"
							:headers="headers" :on-success="success">
							<el-button type="primary">导入合同</el-button>
						</el-upload>
					</div>
					<el-button type="primary" @click="addTemplate">下载导入模板</el-button> -->
					<el-button v-hasPermi="['room:checkout:add']" type="primary" @click="addClick">新增退房</el-button>
					<!-- <el-button type="danger" @click="deleteSelected">删除</el-button> -->
					<el-button v-hasPermi="['room:checkout:export']" @click="exportData" type="warning">导出</el-button>
				</div>
			</el-form>
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
				@selection-change="handleSelectionChange"  :key="tableKey">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column  v-for="(val,key) in titleObj" :prop="key" :label="val"
					align="center">
					<template slot-scope="scope">
						<span v-if="val=='保洁是否确认' || val=='工程是否确认'">{{ scope.row[key]==0?'未确认':'已确认' }}</span>
						<span v-else>{{ scope.row[key] }}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column v-if="key=='fireFlag'||key=='propertyFlag'" style="color: red;" v-for="(val,key) in titleObj" :prop="key"
					:label="val" align="center">
					<template slot-scope="{row}">
							<img style="width: 20px;" v-if="row.status=='即将过期'" src="../../assets/imgs/jg.png" alt="">
							<div :style="{'color':(row.status=='即将过期'?'red':'')}">{{row.status}}</div>
					</template>
				</el-table-column> -->
				<el-table-column prop="tel" label="操作" align="center" width="200">
					<template slot-scope="scope">
						<el-button size="mini" v-hasPermi="['room:checkout:add']" v-if="scope.row.canBeCleaned == 1 && scope.row.isEquipOk == 1 && scope.row.isCheckOut != 1"
						@click="handleCheckOut(scope.row)">确认退房</el-button>
						<el-button size="mini" @click="handleEdit(scope.row)">查看</el-button>
					<!-- 	<el-button size="mini" @click="handleAdjust(scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background :page-size="pageSize" layout="total, prev, pager, next,sizes"
				@current-change="handleCurrentChange" :total="totalNum" @size-change="handleSizeChange" />
		</section>

		<!-- 新增、修改模态框 -->
		<addExitIn :title="title" :obj="obj" @addSubmit="addSubmit" :dialogVisible="dialogVisible">
		</addExitIn>
	</div>
</template>

<script>
	import addExitIn from './component/addExitIn.vue';
	import tableParValueChange from './component/Cje.js';
	export default {
		data() {
			return {
				tableKey:1,
				headers: { //请求头
					Authorization: localStorage.access_token
				},
				oneRow: "", //当checkList列表只有一项时,选择框不可点击
				checkList: ["所属单位", "人才姓名", "退房时间",  "房间号", "是否存在纠纷","纠纷描述"],
				show: false, //控制筛选列的多选框
				titleObj: { //表头
					company: "所属单位",
					name: "人才姓名",
					newTime: "退房时间",
					roomNum: "房间号",
					canBeCleaned: "保洁是否确认",
					isEquipOk: "工程是否确认",
					dispute:'是否存在纠纷',
					describes:'纠纷描述'
				},
				options: [],
				oldTitleObj: {}, //备份表头
				multipleSelection: [],
				formInline: {
					company:'',
					name:'',
					// phone:'',
					roomNum:'',
					// status:'',
					currentPage: 1,
					pageSize: 10,
				},
				oldFormInline: "",
				obj: {},
				tableData: [],
				pageSize: 10, //
				currentPage: 1, //当前页号
				totalNum: 0, //总页数
				title: "",
				dialogVisible: false,
				flag: null,
				formData: {
					name: null,
					type: null,
					signingDate: null,
				},
				adjustVisible: false, //调剂模态框的显隐
				adjustForm: {
					region: null,
				},
			}
		},
		components: {
			addExitIn,
		},
		watch:{
			"$route"(val){
				
				console.log(val);
				// this.getPath()
			}
		},
		mounted() {
		
			console.log(this.$route)
			this.formInline.contractor=this.$route.query.name
			this.oldFormInline = JSON.parse(JSON.stringify(this.formInline))
			this.oldTitleObj = JSON.parse(JSON.stringify(this.titleObj))
			this.getAll()
			this.getRoomTree('')
		},
		methods: {
			
			getRoomTree(company) {
				let newRoomTree = [];
				this.$http.get("/api/roomManage/getRoomTree?company=" + company).then(res => {
					console.log(res);
					res.data.data.forEach((item1, index1) => {
						newRoomTree.push({
							value: item1.building,
							label: item1.building,
							children: [],
						})
						item1.getStoreyRoomResList.forEach((item2, index2) => {
							newRoomTree[index1].children.push({
								value: item2.storey,
								label: item2.storey,
								children: []
							})
							item2.getRoomResList.forEach((item3, index3) => {
								newRoomTree[index1].children[index2].children.push({
									value: item3.id,
									label: item3.roomNumber,
								})
							})
						})
					})
					this.options = newRoomTree;
				})
			},
			clearSearch() {
				this.$refs.myAutocomplete.handleFocus()
			},
			querySearchAsync(queryString, cb) {
				if (this.formInline.company == undefined) {
					this.formInline.company = ''
				}
				console.log("查询条件：", JSON.stringify(this.formInline));
				this.$http.get('/api/ownerManage/getOwners?company=' + this.formInline.company).then(res => {
				    //console.log("查询所有入住中的信息：", res.data.data);
					let result = res.data.data;
					cb(result);
				})
			},
			success(res) {
				if (res.code == 0) {
					this.getAll()
					this.$message.success("导入成功")
				} else {
					this.$message.error("导入失败")
				}
			},
			addTemplate() { //下载导入模板
				this.$http.post(`/api/export/exportContractModel`, {}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "合同导入模板.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},
			checkChange(val) { //筛选列复选框被改变
				var newObj = {}
				for (var key in this.oldTitleObj) {
					if (val.indexOf(this.oldTitleObj[key]) != -1) {
						newObj[key] = this.oldTitleObj[key]
					}
				}
				this.titleObj = newObj;
				if (val.length == 1) { //只有一列时,复选框禁止勾选
					this.oneRow = val[0];
					this.$message.warning("表格内容至少显示一列")
					return;
				}
				this.oneRow = ""
			},
			addSubmit(params) {
				let url = "/api/bdCheckOutRegister/addCheckOutRegister"
				console.log('params:',JSON.stringify(params))
				this.$http.post(url, params).then(res => {
					console.log('res:',JSON.stringify(res))
					if (res.data.code == 0) {
						this.addClose()
						this.$message.success(res.data.message)
						this.getAll();
					} else {
						this.$message.error(res.data.message)
					}

				}).catch(err => {
					console.log(err)
				})
			},
			getAll() {
				this.$http.post("/api/bdCheckOutRegister/queryCheckOutRegister", {
					...this.formInline
				}).then(res => {
					this.tableKey += 1;
					this.tableData = res.data.data.items
					this.totalNum = res.data.data.totalNum
					
					res.data.data.items.forEach(val => {
						// var a=val.time.split('.')[0]
						// var b=a.split('T')[0]
						// var c=a.split('T')[1]
						val.newTime=val.time
						if(val.dispute==true){
							val.dispute='是'
						}else{
							val.dispute='否'
						}
					})
					console.log(res)
				}).catch(err => {
					console.log(err)
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//清空
			handleClear() {
				
				this.formInline = JSON.parse(JSON.stringify(this.oldFormInline))
				this.formInline.contractor=null
				this.getAll()
			},
			//查询
			handleQuery() {

			},
			//子组件关闭父组件弹窗
			addClose() {
				this.title = ''
				this.dialogVisible = false
			},
			// 新增
			addClick() {
				this.title = "新增退房";
				this.dialogVisible = true;
				this.flag = true;

			},
			// 删除所选择的
			deleteSelected() {

			},
			// 导出
			exportData() {
				this.$http.post(`/api/export/exportCheckOutRegister`, {
					...this.formInline,
					headList: this.checkList
				}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "退房登记.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},

			// 编辑
			handleEdit(row) {
				this.title = "查看退房";
				this.dialogVisible = true;
				this.flag = false;
				this.obj = {
					...row
				};
			},
			// 确认退房
			handleCheckOut(row) {
				this.title = "确认退房";
				this.dialogVisible = true;
				this.flag = false;
				this.obj = {
					...row
				};
			},
			// 调剂
			handleAdjust(row) {
				// if (this.multipleSelection.length == 0) {
				// 	this.$message.warning("请勾选要删除的列表")
				// 	return
				// }

				let userId = []
				// this.multipleSelection.forEach(item => {
				// 	userId.push(item.id)
				// })
				userId.push(row.id);

				this.$confirm('此操作将永久删除该成员, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					this.$http.post("/api/bdContract/deleteContract", {
						ids: userId
					}).then(res => {
						if (res.data.code == 0) {
							this.$message.success(res.data.message)
							this.getAll();
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'warning',
						message: '已取消删除'
					});
				});
			},
			// 分页
			// 当前页
			handleCurrentChange(val) {
				console.log(val);
				this.formInline.currentPage = val;
				this.getAll();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getAll();
			},
		}
	}
</script>

<style scoped="scoped">
	section {
		margin-top: 20px;
	}
</style>
